import type { FC } from 'react';
import { JDBCWrapper } from './JDBC.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface JDBCProps { }

const JDBC: FC<JDBCProps> = () => (
   <JDBCWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">JDBC</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text">
         <div>
            <div>
               <p className="text-align-justify">JDBC stands for Java Database Connectivity. It is a Java API to connect and execute the query with the database. JDBC uses JDBC drivers to connect with the database. It can access any kind of tabular data, especially data stored in a Relational Database. </p>
               <p className="text-align-justify">In addition, JDBC is an advancement for ODBC which was platform dependent. To remove dependence, JDBC was developed. It consists of classes and interfaces written in Java. In other words, it acts as a channel between your Java program and databases. It establishes a link between the two.</p>
               <br/>
               <h4 className="text-align-justify"><strong>Steps to connect to database using JDBC :</strong></h4>
               <br/>
               <ul  className="text-align-justify">
                  <li><strong>Loading the Driver</strong> : It means to register your driver. It can be achieved in two ways :
                     <ul>
                        <li><strong>Class.forName() </strong>: Load the driver’s class file into memory at run time.
                           <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                              {
                                 'Class.forName(“oracle.jdbc.driver.OracleDriver”);'
                              }
                           </SyntaxHighlighter>
                        </li>
                        <li><strong>DriverManager.registerDriver() : </strong>The inbuilt class DriverManager consist of a static member register. To load the driver, just call the constructor of the driver class at compile time.
                           <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                              {
                                 'DriverManager.registerDriver(new oracle.jdbc.driver.OracleDriver());'
                              }
                           </SyntaxHighlighter>
                        </li>
                     </ul>
                  </li>
                  <br/>
                  <li><strong>Creating connection : </strong>To establish a connection with the database we use the getConnection() method of DriverManager class.
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'Connection con = DriverManager.getConnection (url,user,password);'
                        }
                     </SyntaxHighlighter>
                  </li>
                  <br/>
                  <li><strong>Creating a statement :</strong> The JDBCStatement, CallableStatement, and PreparedStatement interfaces define some methods. In addition, these methods enable you to send SQL commands and receive data from your database.
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'Statement st = con.createStatement();'
                        }
                     </SyntaxHighlighter>
                  </li>
                  <br/>
                  <li><strong>Executing query :</strong>
                     <ul>
                        <li><strong>executeQuery()</strong> :  To execute queries of retrieving values from the database, we use the executeQuery method. This method returns the object of ResultSet. As a result,  that can be used to get all the records of a table.</li>
                        <li><strong>executeUpdate(sql query)</strong> : To execute queries of updating/inserting, we use executeUpdate method.</li>
                     </ul>
                  </li>
                  <br/>
                  <li><strong>Closing connection :</strong> It will close the objects of Statement and ResultSet automatically. To close the connection, we use the close() method of Connection interface.
                     <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                        {
                           'con.close();'
                        }
                     </SyntaxHighlighter>
                  </li>
               </ul>
            </div>
         </div>
         <br/>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'import java.sql.*;\n' +
               'import java.util.*;\n' +
               '\n' +
               'class JDBCdemo {\n' +
               '  public static void main(String args[]) {\n' +
               '    String url = "jdbc:oracle:thin:@localhost:1521:xe";\n' +
               '    String user = "user";\n' +
               '    String password = "test123";\n' +
               '\n' +
               '    Scanner scanner = new Scanner(System.in);\n' +
               '    System.out.println("Enter name");\n' +
               '    String name = scanner.next();\n' +
               '\n' +
               '    try {\n' +
               '      //Loading the driver	\n' +
               '     DriverManager.registerDriver(new oracle.jdbc.OracleDriver());\n' +
               '\n' +
               '      //Creating the connection\n' +
               '      Connection connection = DriverManager.getConnection(url, user, password);\n' +
               '\n' +
               '      //Creating statement\n' +
               '      Statement statement = connection.createStatement();\n' +
               '\n' +
               '      //Executing query\n' +
               '      statement.executeUpdate("insert into student values(" \'+name+\' ")");\n' +
               '      ResultSet resultSet = statement.executeQuery("select * from student");\n' +
               '      while (resultSet.next()) {\n' +
               '        System.out.println(resultSet.getInt(1) + " " + resultSet.getString(2));\n' +
               '      }\n' +
               '\n' +
               '      //Closing the connection\n' +
               '      connection.close();\n' +
               '\n' +
               '    }\n' +
               '    catch (Exception e) {\n' +
               '      System.out.println(e);\n' +
               '    }\n' +
               '  }\n' +
               '}'
            }
         </SyntaxHighlighter>
      </div>
   </JDBCWrapper>
);

export default JDBC;
